import styled from 'styled-components';

export const PageLayout = styled.div`
  position: relative;
  margin-left: 5vw;
  margin-right: 5vw;

  padding-bottom: 80px;
  flex: 1;
`;

export const Title = styled.h2`
  font-family: sans-serif;
  font-size: 36px;
  line-height: 1.1;
  font-weight: 700;

  padding-top: 32px;
  padding-bottom: 24px;
`;

export const Dashboard = styled.div`
  display: flex;
  flex-direction: column;

  .tilesRow {
    display: flex;
    &:first-of-type {
      padding-bottom: 20px;
    }
    & > *:first-of-type {
      margin-right: 20px;
    }

    &:first-of-type > *:first-of-type {
      background-color: #99d4de;
      border-color: #99d4de;
      &:hover {
        background-color: #a6e5f0;
        border-color: #8ec6d0;
      }
    }
    &:first-of-type > *:last-of-type {
      background-color: #67bfcc;
      border-color: #67bfcc;
      &:hover {
        background-color: #70d2e0;
        border-color: #57a8b4;
      }
    }
    &:last-of-type > *:first-of-type {
      background-color: #33aabc;
      border-color: #33aabc;
      &:hover {
        background-color: #3bc1d5;
        border-color: #30a0b1;
      }
    }
    &:last-of-type > *:last-of-type {
      background-color: #0e94a9;
      border-color: #0e94a9;
      &:hover {
        background-color: #13a7be;
        border-color: #10879a;
      }
    }
  }

  .tile {
    color: white;
    font-size: 48px;
    width: 100%;
    height: 215px;
    padding: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    background: lightblue;

    border: 2px solid transparent;
    transition: background-color 0.2s ease 0s, border-color 0.2s ease 0s;

    &__icon {
      margin-right: 16px;
    }
  }
`;
